<template>
  <b-container>
    <b-row class="justify-content-end">
      <b-button variant="info" class="mt-3 mx-3" @click="goToCreateTopic">افزودن سرفصل جدید</b-button>
    </b-row>
    <b-row class="mt-4">
      <b-card class="w-100 shadow text-right m-3">
        <b-container>
          <b-row class="justify-content-end align-items-center">
            <b-col md="2">
              <b-button pill variant="outline-info" size="sm" @click="searchTopics" class="w-100"><b-icon icon="search" class="m-1"></b-icon> جستجو</b-button>
              <b-button v-if="searchTerm.length > 0" pill size="sm" variant="outline-secondary" @click="clearSearch" class="w-100 mt-1"><b-icon icon="x" class="m-1"></b-icon>پاک کردن</b-button>
            </b-col>
            <b-col md="6">
              <label for="input_searchBy" class="text-right w-100 mt-3">جستجو</label>
              <b-form-input type="search" class="w-100 rtl" v-model="searchTerm" :placeholder="(selectSearchBy.selected.length > 0) ? selectSearchBy.selected.map((o) => o.value).join(' , ') + ' ... ' : 'جستجو در عنوان و توضیحات'"></b-form-input>
            </b-col>
            <b-col md="4">
              <label for="input_searchBy" class="text-right w-100 mt-3">جستجو بر اساس</label>
              <multiselect id="input_searchBy" v-model="selectSearchBy.selected" :options="selectSearchBy.options" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" 
                selectLabel="فشردن Enter برای انتخاب" selectedLabel="انتخاب شده" deselectLabel="فشردن Enter برای رد انتخاب" noOptions="موردی یافت نشد"
                :placeholder="selectSearchBy.first" label="value" track-by="value" @input="onSearchByChanged"></multiselect>
            </b-col>
          </b-row>
        </b-container>
      </b-card>
    </b-row>
    <b-row>
      <p v-show="nothingToShow" class="text-center text-secondary rtl w-100">هیچ سرفصلی یافت نشد <b-button pill variant="outline-secondary" size="sm" @click="goToCreateTopic">افزودن جدید</b-button></p>
      <b-card v-show="!nothingToShow" class="w-100 shadow text-right m-3">
        <b-table striped hover :items="topicTable.items" :fields="topicTable.fields"  no-local-sorting @sort-changed="onTableSortChanged"
          id="table_topic" :busy="loading" caption-top :sort-by.sync="topicTable.sortBy" :sort-desc.sync="topicTable.sortDesc">
          <template #table-caption>لیست سرفصل ها</template>
          <template #table-busy>
            <div class="text-center text-info my-2">
              در حال دریافت اطلاعات
              <b-spinner class="align-middle m-1" small></b-spinner>
            </div>
          </template>
          <template #cell(actions)="row">
            <b-button variant="outline-info" size="sm" class="m-1" :href="'https://meshkat.resalatuniversity.ir/explore/documents?limit=20&page=1&select=abstract&topic_ids='+topics[row.index]._id" target="_blank" rel="noopener noreferrer"><b-icon icon="box-arrow-up-right" class="m-1"></b-icon>مشاهده</b-button>
            <b-button variant="outline-info" size="sm" @click="editTopicRow(row)" class="mr-1"><b-icon icon="pencil" class="m-1"></b-icon>ویرایش</b-button>
          </template>
        </b-table>
        <b-pagination
          v-show="pagination.count != 0"
          v-model="pagination.page"
          :total-rows="pagination.count"
          :per-page="pagination.limit"
          class="mt-3"
          align="center"
          aria-controls="table_topic"
          @page-click="clickOnPage"
        ></b-pagination>
      </b-card>
    </b-row>
  </b-container>
</template>
<script>
import _ from 'lodash'

export default {
  name: 'TopicsTable',
  data: () => ({
    loading: false,
    selectSearchBy: {
      options: [
        { key: "title", value: "عنوان" },
        { key: "description", value: "توضیحات" }
      ],
      selected: [],
      first: 'پیش فرض'
    },
    topics: [],
    topicTable: {
      fields: [
        {
          key: "title",
          label: "عنوان",
        },
        {
          key: "created_at",
          label: "تاریخ ایجاد",
          sortable: true
        },
        {
          key: "updated_at",
          label: "تاریخ آخرین ویرایش",
          sortable: true
        },
        {
          key: "actions",
          label: "عملیات"
        }
      ].reverse(), //for rtl support
      items: [],
      sortBy: 'created_at',
      sortDesc: true
    },
    searchTerm: '',
    queryParams: {},
    nothingToShow: false,
    pagination: {
      count: 0,
      page: 1,
      limit: 20
    },
  }),
  created() {
    this.loadLatestQueryParamsState()
  },
  mounted() {
    this.fetchTopicsData()
  },
  methods: {
    fetchTopicsData() {
      this.loading = true

      this.$axios.get('/topics', {
        params: this.queryParams
      }).then((response) => {
        const body = response.data
        if (body.count == 0) {
          this.nothingToShow = true 
        } else {
          this.topics = body.data
          this.topicTable.items = _.map(body.data, (o) => {
            return {
              title: o.title,
              created_at: o.formated_jalali_created_at,
              updated_at: o.formated_jalali_updated_at
            }
          })
          this.pagination.count = body.count
        }
      }).catch((err) => {
        this.$bvToast.toast(err.text, { variant: 'danger', title: 'خطا' })
      }).finally(() => {
        this.$store.commit('setFetchDataParamsState', { topic: this.queryParams })
        this.loadLatestPagination()
        this.loading = false
      })
    },
    loadLatestPagination() {
      this.pagination.page = this.queryParams.page
      this.pagination.limit = this.queryParams.limit
    },
    loadLatestQueryParamsState() {
      this.queryParams = this.$store.state.fetchDataParams?.topic
      if (this.queryParams) {
        if (this.queryParams.q) {
            this.searchTerm = this.queryParams.q
        }
        if (this.queryParams.search_by) {
          this.selectSearchBy.selected = _.map(this.queryParams.search_by.split(','), (searchByKey) => {
            return {
              key: searchByKey,
              value: this.selectSearchBy.options.find(elem => elem.key == searchByKey).value
            }
          })
        }
        if (this.queryParams.sort_by) {
          this.topicTable.sortBy = this.queryParams.sort_by
          this.topicTable.sortDesc = (this.queryParams.sort_order == 'desc')
        }
        this.loadLatestPagination()
      } else {
        this.queryParams = {
          limit: this.pagination.limit,
          page: this.pagination.page
        }
      }
    },
    searchTopics() {
      if (this.searchTerm && typeof this.searchTerm == 'string' && this.searchTerm.length > 0) {
        this.queryParams["q"] = this.searchTerm
      }
      this.fetchTopicsData()
    },
    goToCreateTopic() {
      this.$router.push({ name: 'CreateTopic' })
    },
    editTopicRow(row) {
      let topic = this.topics[row.index]
      this.$router.push({ name: 'EditTopic', params: { topic_id: topic._id }})
    },
    clickOnPage(bvEvent, page) {
      bvEvent.preventDefault()
      this.pagination.page = this.queryParams.page = page
      this.fetchTopicsData()
    },
    clearSearch() {
      this.searchTerm = ''
      delete this.queryParams.q
      this.nothingToShow = false
      this.fetchTopicsData()
    },
    onTableSortChanged({ sortBy, sortDesc }) {
      this.queryParams["sort_by"] = sortBy
      this.queryParams["sort_order"] = (sortDesc) ? 'desc' : 'asc'
      this.fetchTopicsData()
    },
    onSearchByChanged() {
      if (Array.isArray(this.selectSearchBy.selected) && this.selectSearchBy.selected.length > 0) {
        this.queryParams["search_by"] = _.chain(this.selectSearchBy.selected).map('key').join(',').value()
      } else {
        delete this.queryParams["search_by"]
      }
      this.fetchTopicsData()
    }
  }
}
</script>